interface IProps {
    onClickNumberBtn: (number: string) => void;
    OnClickDeleteBtn: () => void;
    onClickAllClearBtn: () => void;
}

const PinNumberPad = ({ onClickNumberBtn, OnClickDeleteBtn, onClickAllClearBtn }: IProps) => {
    return (
        <div className="pin-keypad">
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="1"
                onClick={() => onClickNumberBtn('1')}
            >
                1
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="2"
                onClick={() => onClickNumberBtn('2')}
            >
                2
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="3"
                onClick={() => onClickNumberBtn('3')}
            >
                3
            </button>

            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="4"
                onClick={() => onClickNumberBtn('4')}
            >
                4
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="5"
                onClick={() => onClickNumberBtn('5')}
            >
                5
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="6"
                onClick={() => onClickNumberBtn('6')}
            >
                6
            </button>

            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="7"
                onClick={() => onClickNumberBtn('7')}
            >
                7
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="8"
                onClick={() => onClickNumberBtn('8')}
            >
                8
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="9"
                onClick={() => onClickNumberBtn('9')}
            >
                9
            </button>

            <button
                type="button"
                className="pin-key pin-key-clear text-base font-medium"
                id="pinClearBtn"
                onClick={onClickAllClearBtn}
            >
                전체삭제
            </button>
            <button
                type="button"
                className="pin-key heading-2 font-bold"
                data-number="0"
                onClick={() => onClickNumberBtn('0')}
            >
                0
            </button>
            <button type="button" className="pin-key pin-key-delete" id="pinDeleteBtn" onClick={OnClickDeleteBtn}>
                <img src="./images/delete-icon.png" alt="삭제" className="pin-key-delete-icon" />
            </button>
        </div>
    )
}

export default PinNumberPad;